import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  browserLocalPersistence,
  createUserWithEmailAndPassword,
  deleteUser,
  updateEmail as firebaseUpdateEmail,
  updatePassword as firebaseUpdatePassword
} from 'firebase/auth';
import { auth, getPerf } from '../firebase';

let currentUser = null;

// Auth durumunu izle
const initAuth = () => {
  return new Promise((resolve) => {
    onAuthStateChanged(auth, (user) => {
      currentUser = user;
      resolve(user);
    });
  });
};

// Kullanıcı oluştur
const createUser = async (email, password) => {
  const perf = await getPerf();
  const trace = perf.trace('createUser');
  trace.start();

  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    currentUser = userCredential.user;
    trace.putAttribute('success', 'true');
    return userCredential.user;
  } catch (error) {
    trace.putAttribute('success', 'false');
    trace.putAttribute('error', error.code);
    throw error;
  } finally {
    trace.stop();
  }
};

// Kullanıcı sil
const removeUser = async () => {
  const perf = await getPerf();
  const trace = perf.trace('removeUser');
  trace.start();

  try {
    await deleteUser(currentUser);
    currentUser = null;
    trace.putAttribute('success', 'true');
  } catch (error) {
    trace.putAttribute('success', 'false');
    trace.putAttribute('error', error.code);
    throw error;
  } finally {
    trace.stop();
  }
};

// Email güncelle
const updateUserEmail = async (newEmail) => {
  const perf = await getPerf();
  const trace = perf.trace('updateEmail');
  trace.start();

  try {
    await firebaseUpdateEmail(currentUser, newEmail);
    trace.putAttribute('success', 'true');
  } catch (error) {
    trace.putAttribute('success', 'false');
    trace.putAttribute('error', error.code);
    throw error;
  } finally {
    trace.stop();
  }
};

// Şifre güncelle
const updateUserPassword = async (newPassword) => {
  const perf = await getPerf();
  const trace = perf.trace('updatePassword');
  trace.start();

  try {
    await firebaseUpdatePassword(currentUser, newPassword);
    trace.putAttribute('success', 'true');
  } catch (error) {
    trace.putAttribute('success', 'false');
    trace.putAttribute('error', error.code);
    throw error;
  } finally {
    trace.stop();
  }
};

// Giriş yap
const signIn = async (email, password) => {
  const perf = await getPerf();
  const trace = perf.trace('signIn');
  trace.start();

  try {
    await auth.setPersistence(browserLocalPersistence);
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    currentUser = userCredential.user;
    trace.putAttribute('success', 'true');
    return userCredential.user;
  } catch (error) {
    trace.putAttribute('success', 'false');
    trace.putAttribute('error', error.code);
    throw error;
  } finally {
    trace.stop();
  }
};

// Çıkış yap
const signOut = async () => {
  const perf = await getPerf();
  const trace = perf.trace('signOut');
  trace.start();

  try {
    await firebaseSignOut(auth);
    currentUser = null;
    trace.putAttribute('success', 'true');
  } catch (error) {
    trace.putAttribute('success', 'false');
    trace.putAttribute('error', error.code);
    throw error;
  } finally {
    trace.stop();
  }
};

// Mevcut kullanıcıyı getir
const getCurrentUser = () => currentUser;

// Kullanıcının giriş yapmış olup olmadığını kontrol et
const isAuthenticated = () => !!currentUser;

export {
  initAuth,
  createUser,
  removeUser,
  updateUserEmail,
  updateUserPassword,
  signIn,
  signOut,
  getCurrentUser,
  isAuthenticated
}; 